import { ContextType } from "../../Wrap/Constants/Enums/ContextType";

export class RoutesHelper {
    public static culturePlaceholder = "{culture}";
    public static contextTypePlaceholder = "{contexttype}";
    public static contextIdPlaceholder = "{contextid}";

    public static replacePlaceholdersInUrl(
        url: string,
        culture: string,
        contextType?: ContextType,
        contextId?: string
    ): string {
        if (culture == null || !culture.length) {
            culture = RoutesHelper.getDefaultCulture();
        }

        url = url.replace(RoutesHelper.culturePlaceholder, culture);

        if (
            contextType != null &&
            contextType !== ContextType.None &&
            contextId &&
            contextId.length &&
            contextId.length > 0
        ) {
            const contextString: string = RoutesHelper.contextTypes[contextType];
            url = url.replace(RoutesHelper.contextTypePlaceholder, contextString);
            url = url.replace(RoutesHelper.contextIdPlaceholder, contextId);
        }

        return url;
    }

    private static contextTypes: string[] = ["customer", "account", "subaccount"];

    private static getDefaultCulture(): string {
        return "en-gb";
    }
}
